import { InjectionToken } from '@angular/core';
import { TokenTypeValue } from '@shared/shared/auth/common/constants/token-type';

export const AUTH_TOKENS_STORAGE_CONFIGURATION = new InjectionToken<Record<TokenTypeValue, string>>(
  'LocalStorage names of stored tokens'
);
